import {
    FETCH_NON_ALLOCATED_EMP_REQUEST,
    FETCH_NON_ALLOCATED_EMP_SUCCESS,
    FETCH_NON_ALLOCATED_EMP_FAILURE,
} from "../constants/NonAllocatedEmpConstatns";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const NonAllocatedEmpReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_NON_ALLOCATED_EMP_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_NON_ALLOCATED_EMP_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_NON_ALLOCATED_EMP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default NonAllocatedEmpReducer;
